import { render, staticRenderFns } from "./ListProductStock.vue?vue&type=template&id=5af87b3f"
import script from "./ListProductStock.vue?vue&type=script&lang=js"
export * from "./ListProductStock.vue?vue&type=script&lang=js"
import style0 from "./ListProductStock.vue?vue&type=style&index=0&id=5af87b3f&prod&scope=true&lang=css"
import style1 from "./ListProductStock.vue?vue&type=style&index=1&id=5af87b3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports